/* eslint-disable */
import { useState } from 'react';
import { connect } from 'react-redux';
import { BaseModal } from '../BaseModal';
import { modalActions } from '../../../Actions';
import { notificationServices } from '../../../Services';

const LabelledInput = (props) => {
	const {
		value, onChange, id, name, placeholder, labelText, mandatory,
	} =
		props;
	return (
		<div className="flex flex-col gap-2 p-2 w-full mt-4">
			<label
				htmlFor={id}
				className="text-sm font-medium text-gray-700 text-left"
			>
				{labelText}
				{mandatory && <span className="text-red-500 ml-0.5">*</span>}
			</label>

			<input
				id={id}
				name={name}
				value={value}
				onChange={onChange}
				placeholder={placeholder}
				className='w-full border border-gray-300 rounded-md px-4 py-2.5 text-gray-700 placeholder-gray-400 
					focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500 transition'
			/>
		</div>

	);
};

const AddNewGroupModal = ({ show, toggleModal, onSubmit, filterLabels = {} }) => {
	const [groupName, setGroupName] = useState('');

	const handleClose = () => {
		toggleModal(false);
		setGroupName('');
	};

	const handleSubmit = () => {
		if (!groupName) {
			notificationServices.generateNotification({
				type: 'error',
				message: 'Please enter a group name.',
			});
			return;
		}
		onSubmit(groupName);
		handleClose();
	};

	return (
		<BaseModal
			open={show}
			heading={filterLabels?.addGroup ?? 'Add New Group'}
			handleClose={handleClose}
			renderBtns={() => {
				return (
					<div className='flex justify-end gap-4 mb-4 px-2 w-full'>
						<button
							onClick={handleClose}
							className='w-fit py-2 px-4 text-[14px] rounded-md border border-gray-300 text-gray-700 font-semibold bg-white shadow-sm hover:bg-gray-50 transition'
						>
							CANCEL
						</button>

						<button
							onClick={handleSubmit}
							disabled={!groupName}
							className={`w-fit py-2 px-4 text-[16px] rounded-md font-semibold shadow-sm transition
									${groupName
									? 'bg-yellow-500  hover:bg-yellow-600'
									: 'bg-gray-200 text-gray-400 cursor-not-allowed'
								}
							`}
						>
							SAVE
						</button>
					</div>

				);
			}}
			width='25rem'
			height='20rem'
		>
			<div className=' border-gray-300 border-t'>
				<LabelledInput
					mandatory
					id='groupName'
					name='GROUP_NAME'
					value={groupName}
					placeholder={filterLabels.enterGroupName ?? 'Enter GroupName'}
					labelText={filterLabels.groupName ?? 'Group Name'}
					onChange={(e) => { return setGroupName(e.target.value); }}
				/>
			</div>
		</BaseModal>
	);
};

const mapStateToProps = (state) => {
	const { show, data } = state.modal.addGroupModal;
	return {
		show,
		data,
	};
};

const mapDispatchToProps = {
	toggleModal: modalActions.toggleAddGroupModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddNewGroupModal);
